module.exports = __webpack_public_path__ + "static/media/cook_food_map_important.840b1d63.svg";